import React from "react";
import Card from "../../../Reserves/Components/Card";
import CustomSlider from "../../../Reserves/Components/CustomSlider";
const index = ({ data, single = false }) => {
  return (
    <div id="looklike-single" className="py-3">
      <div className="p-2 mb-1">
        <h4>مجموعه های برتر مشابه</h4>
      </div>
      <div className="row">
        <CustomSlider
          data={data}
          renderCard={(data, count) => {
            return <Card data={data} key={count} single={single} />;
          }}
          isReserve={true}
          numbers={4}
        />
      </div>
    </div>
  );
};

export default index;
